import { MENU_CHANGE, LANGUAGE_CHANGE, SIGN_IN } from "../constants";
const initialState = {
  language: "az",
  menu: 0,
  bearerToken: undefined,
};

const navigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case MENU_CHANGE:
      return {
        ...state,
        menu: action.payload,
      };
    case LANGUAGE_CHANGE:
      return {
        ...state,
        language: action.payload,
      };

    case SIGN_IN:
      return {
        ...state,
        bearerToken: action.payload,
      };

    default:
      return state;
  }
};
export default navigationReducer;
